import { createFileRoute } from '@tanstack/react-router'

import { MessageReportScreen } from './-components/message-report-screen.tsx'

export const Route = createFileRoute('/cs-tools/message-report')({
  component: MessageReportScreen
})
